import Axios, { Response } from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export const PRODUCT_TYPE_DELIVERY = 0;
export const PRODUCT_TYPE_EXTENSION = 2;
export const PRODUCT_TYPE_RENTAL_DIRECT = 3;
export const PRODUCT_TYPE_RENTAL_SMS = 4;

export type OrderHistory = {
  order: Order;
};

export type SetMenuGroup = {
  set_prd_type_id: number;
  set_prd_type_min: number;
  set_prd_type_name: string;
  set_product: SetMenu[];
};

export type SetMenu = {
  product_id: number;
  product_name: string;
  product_total_amount: number;
  product_price: number;
  options: Option[];
};

export type Coupon = {
  coupon_id: number;
  coupon_name: string;
  coupon_detail_id: number;
  com_discount_amount: number;
  store_discount_amount: number;
  used_at: string;
};

export type Order = {
  order_id?: string;
  table_area_nr?: number;
  table_nr?: number;
  is_active?: number;
  is_complete?: number;
  completed_at?: null | string;
  child?: OrderChild[];
};

export type OrderChild = {
  confirmed_at?: string;
  delivery_tip?: number;
  room_tip: number;
  order_seq?: number;
  order_status: number;
  ordered_at: string;
  payment_type: number;
  payment_status: number;
  bill_number: string;
  order_nr: null | number;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  prepared_at: null | string;
  picked_up_at: null | string;
  cancelled_at: null | string;
  cancel_description: null | string;
  detail: Product[];
  store_discount_amount?: number;
  com_discount_amount?: number;
  delivery_address?: string;
  store_name?: string;
  coupons?: Coupon[];
};

export type Product = {
  product_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set: number;
  has_option: number;
  product_status: number;
  product_price: number;
  product_discount_name: '';
  product_discount: number;
  product_discount_amount: number;
  product_quantity: number;
  product_org_price: number;
  product_tax: number;
  product_tax_name: null | string;
  product_tax_rate: string;
  product_total_amount: number;
  request_id: number;
  request_message: string;
  prepared_at: string;
  cancelled_at: string;
  cancel_description: string;
  options: Option[];
  set_options: Product;
  set_prd_type_list: SetMenuGroup[];
};

export type SetPrdType = {
  set_prd_type_id: number;
  set_prd_type_name: string;
  set_prd_type_min: number;
  set_product: SetProduct[];
};

export type SetProduct = {
  product_id: number;
  product_name: string;
  product_price: number;
  product_total_amount: number;
  options: Option[];
};

export type Option = {
  option_id: number;
  option_name: string;
  option_price: number;
  option_type_id?: number;
  option_type_name?: number;
};
export type HotelOrderDataType = {
  hotel_amount: number;
  order_count: number;
  settlement_date: string;
  settlement_start_date: string;
};
export type HotelStoreSummaryType = {
  hotel_amount: string;
  order_count: string;
  store_id: number;
  store_name: string;
};

export type HotelMonthSummaryType = {
  hotel_amount: number;
  hotel_amount_count: number;
  room_tip: number;
  hotel_direct_amount: number;
  hotel_direct_amount_count: number;
};

export type HotelStoreTimeSummaryType = {
  hour: number;
  hotel_amount: number;
  order_count: number;
};

export type OrderChildType = {
  order_seq: number;
  order_status: number;
  next_order_status: number;
  ordered_at: string;
  payment_type: number;
  payment_status: number;
  delivery_address: string;
  delivery_address_detail: string;
  delivery_estimated_time: number;
  delivery_prepared_time?: number;
  delivery_type: number;
  delivery_tip: number;
  room_tip: number;
  bill_number: string;
  order_nr: null;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  inquiry: string;
  created_at: string | null;
  confirmed_at: string | null;
  prepared_at: string | null;
  picked_up_at: string | null;
  completed_at: null | string;
  delivery_expected_at: null | string;
  delivery_completed_at: null | string;
  cancelled_at: string | null;
  cancel_description: string | null;
  hotel_name: string;
  hotel_phone_number: string;
  store_discount_amount: number;
  store_phone_number: string;
  com_discount_amount: number;
  order_category: number;
  order_check_type: number;
  customer_phone_number: string | null;
  email: string | null;

  detail: {
    product_id: number;
    product_seq: number;
    set_product_seq: number;
    product_name: string;
    is_set: number;
    has_option: number;
    product_status: number;
    product_price: number;
    product_discount_name: string;
    product_discount_amount: number;
    product_quantity: number;
    product_tax: number;
    product_tax_name: string | null;
    product_tax_rate: string;
    product_total_amount: number;
    request_id: null;
    request_message: null;
    prepared_at: string | null;
    cancelled_at: string | null;
    cancel_description: string | null;
    set_prd_type_list: SetPrdType[];
    options: Option[];
  }[];
};

export type KnockOrderType = {
  app_name: 'KNOCK';
  store_name: string;
  order_id: string;
  table_area_nr: number;
  table_nr: number;
  is_active: number;
  is_complete: number;
  completed_at: string | null;
  created_at: string;
  child: OrderChildType[];
  store_id: number;
  parent_store_id: number;
  payment?: paymentRealmType[];
};

export type KnockOrderItemType = {
  app_name: 'KNOCK';
  store_name: string;
  order_id: string;
  store_id: number;
  table_area_nr: number;
  table_nr: number;
  parent_store_id: number;
  child: OrderChildType;
  payment?: paymentRealmType[];
};

export type paymentRealmType = {
  tran_result?: boolean;
  tran_msg?: string;
  payment_van_id?: string;
  store_id?: string | number;
  order_id?: string;
  bill_number?: string;
  order_seq?: string | number;
  pay_seq?: string | number;
  van_type?: string;
  tran_type?: string;
  pay_type?: string;
  easy_type?: string;
  response_code?: string;
  amount?: number;
  vat_amount?: number;
  service_amount?: number;
  installment?: number;
  approval_no?: string;
  approval_date?: string;
  org_payment_van_id?: string;
  org_approval_no?: string;
  org_approval_date?: string;
  cancel_fg?: number;
  issuer_code?: string;
  issuer_name?: string;
  acquirer_code?: string;
  acquirer_name?: string;
  store_no?: string;
  cat_id?: string;
  balance?: string;
  response_msg?: string;
  card_no?: string;
  card_type?: string;
  tran_management_no?: string;
  tran_serial_no?: string;
  occurrence_point?: string;
  available_point?: string;
  accumulated_point?: string;
  cashback_store?: string;
  cashback_approval_no?: string;
  dcc_flag?: string;
  device_number?: string;
  key_data?: string;
  store_data?: string;
  edc_flag?: string;
  gift_amt?: string;
  biz_no?: string;
  notice?: string;
  cash_type?: string;
  cash_no?: string;
  send_server?: boolean;
  created_at?: Date;
  order_created_at?: Date;
  updated_at?: Date;
  cancelled_at?: Date;
  payment_at?: Date;
  org_payment_at?: Date;
};

export type OrderProductType = {
  product_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set: number;
  has_option: number;
  product_status: number;
  product_price: number;
  product_discount_name: string;
  product_discount_amount: number;
  product_quantity: number;
  product_tax: number;
  product_tax_name: null | string;
  product_tax_rate: string;
  product_total_amount: number;
  request_id: number | null;
  request_message: string | null;
  prepared_at: string | null;
  cancelled_at: string | null;
  cancel_description: string | null;
  set_prd_type_list: SetPrdType[];
  options: Option[];
};

export type OrderStatusType = {
  store_id: number;
  parent_store_id: number;
  order_id: string;
  order_seq: number;
  order_status: number;
  delivery_estimated_time?: number;
  expected_at?: string;
  cancel_description?: string;
  table_area_nr: number;
  user_token_id: number;
  table_nr: number;
  status_changed_at: string;
};
export type SalesType = {
  start_date: string;
  end_date: string;
};
export type SalesListType = {
  data_type: 'order';
  cancel_description: string;
  cancelled_at: string;
  com_discount_amount: number;
  completed_at: string;
  confirmed_at: string;
  delivery_address: string;
  delivery_completed_at: string;
  delivery_expected_at: string;
  delivery_started_at: string;
  delivery_tip: number;
  delivery_type: number;
  hotel_name: string;
  inquiry: string;
  order_id: string;
  order_seq: number;
  order_status: number;
  ordered_at: string;
  payment_status: number;
  pickup_name: string;
  prepared_at: string;
  store_discount_amount: number;
  store_name: string;
  total_amount_incl: number;
  total_amount_org: number;
  bill_number: string;
  delivery_address_detail: string;
  issuer_name: string;
  delivery_score: null | number;
  food_score: null | number;
  content: null | string;
  lang: number;
  room_tip: number;
};

const OrderController = {
  getHisDetail: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/order/hisDetail';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getHisDetail 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getHotelOrderData: async (oParams: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/order/getHotelOrderData';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getHotelOrderData 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getHotelStoreSummary: async (oParams: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/order/getHotelStoreSummary';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getHotelStoreSummary 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getHotelMonthSummary: async (oParams: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/order/getHotelMonthSummary';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getHotelMonthSummary 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getHotelStoreTimeSummary: async (oParams: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/order/getHotelStoreTimeSummary';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getHotelStoreTimeSummary 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getPosOrderComplete: async (oParams: any) => {
    let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/getPosOrderComplete`;

    const response: any = await Axios.post(sUrl, oParams);

    if (response && response.data) {
      const oRes = response.data;
      let orderList: KnockOrderType[] = [];

      if (oRes.ok && oRes.data.length > 0) {
        orderList = oRes.data;
      }

      return orderList;
    }
  },

  getPosOrderNotComplete: async () => {
    let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/getPosOrderNotComplete`;

    const response: any = await Axios.post(sUrl);

    if (response && response.data) {
      const oRes = response.data;
      let orderList: KnockOrderType[] = [];

      if (oRes.ok && oRes.data.length > 0) {
        orderList = oRes.data;
      }

      return orderList;
    }
  },

  // status 업데이트
  updateStatus: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/updateStatus`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[주문상태 업데이트 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  // knockknock 배달 매출현황
  getSalesList: async (oParams: SalesType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/getKnockOrder';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 배달 매출 현황 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 강제배달완료처리
  completeOrderHotelAdmin: async (oParams: any) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/order/completeOrderHotelAdmin';
      console.log('sUrl>>>>', sUrl);
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[knockknock 강제배달완료처리 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default OrderController;
